export default __webpack_public_path__ + "static/media/Thorin's Letter to Bilbo_03.ae4bc3b0.jpg";